const StoreContext = void 0;
export {
  StoreContext
};
